export const globalPromotionsManager = {
  header: {
    title: "Gestión de Promociones",
    description:
      "Crea y administra promociones globales de estancia. Estarán disponibles para cualquiera de tus propiedades (apartamentos y hoteles).",
  },

  toolbar: {
    info: "Las promociones creadas aquí se pueden activar desde la pestaña <strong>Promociones</strong> de cada propiedad.",
    newPromotion: "Nueva Promoción",
  },

  loading: "Cargando promociones…",
  close: "Cerrar",
  cancel: "Cancelar",
  noLimit: "Sin límite",

  status: {
    active: "Activa",
    paused: "Pausada",
  },

  card: {
    stay: "Estadía",
    discount: "Descuento",
    validity: "Validez",
    edit: "Editar",
    delete: "Eliminar",
  },

  nights: {
    range: "{min} – {max} noches",
    min: "{min}+ noches",
  },

  discount: {
    fixed: "{value} (fijo)",
  },

  empty: {
    title: "No hay promociones creadas",
    description:
      "Crea promociones para incentivar estadías más largas. Podrás activarlas en cada propiedad desde su configuración de reservas directas.",
    create: "Crear Primera Promoción",
  },

  form: {
    editTitle: "Editar Promoción",
    createTitle: "Nueva Promoción",
    nameLabel: "Nombre de la promoción",
    namePlaceholder: "Ej: Descuento 7 Noches, Promo Semana",
    minNights: "Noches mínimas",
    maxNights: "Noches máximas",
    optional: "(opcional)",
    noLimitPlaceholder: "Sin límite",
    discountType: "Tipo de descuento",
    percentage: "Porcentaje",
    fixedAmount: "Monto Fijo",
    discountValue: "Valor del descuento",
    amountSuffix: "monto",
    validFrom: "Válida desde",
    validTo: "Válida hasta",
    activateNow: "Activar promoción inmediatamente",
    propertiesLabel: "Propiedades donde estará disponible",
    selectAll: "Marcar todas",
    propertiesHelper:
      "Se crearán registros de configuración para las propiedades seleccionadas.",
    infoBox:
      "Después podrás ajustar badge, orden y comportamiento desde la pestaña <strong>Promociones</strong> de cada propiedad.",
    saving: "Guardando…",
    update: "Actualizar",
    create: "Crear Promoción",
  },

  deleteModal: {
    title: "Eliminar promoción",
    warningStrong: "Esta acción no se puede deshacer.",
    warningBefore: "Vas a eliminar la promoción",
    warningAfter: ". Dejará de estar disponible en todas las propiedades.",
    confirmLabel: "Escribe el nombre exacto para confirmar:",
    confirmPlaceholder: "Escribe el nombre de la promoción",
    deleting: "Eliminando…",
    confirmDelete: "Eliminar definitivamente",
  },

  toasts: {
    loadError: "No se pudieron cargar las promociones.",
    nameRequired: "Ingresa un nombre para la promoción",
    minNightsWarning: "Las noches mínimas deben ser al menos 1",
    discountValueWarning: "El valor del descuento debe ser mayor a 0",
    selectProperty: "Selecciona al menos una propiedad",
    updated: "Promoción actualizada",
    created: "Promoción creada correctamente",
    saveFailed: "No se pudo guardar",
    saveError: "Error al guardar la promoción",
    deleted: "Promoción eliminada",
    deleteFailed: "No se pudo eliminar",
    deleteError: "Error al eliminar",
  },
};
